import { EGeoDetailType, IGeoAddressItem } from '../../../types/reducers/offer';

interface IParams {
  locationPath: Array<number>;
  geoId: number;
  geoType: string;
}

export const mapAddress = (params: IParams): Array<IGeoAddressItem> => {
  const { locationPath, geoId, geoType } = params;

  /**
   * locationPath приходит с сервера в обратной последовательности (то есть, «от частного к общему»).
   * Для адреса нужна прямая последовательность, поэтому «переворачиваем» массив.
   */
  const locationPathParentToChild = [...locationPath].reverse();

  /**
   * Формируем первые элементы списка address из locationPath.
   *
   * Список нужен исключительно для фронта, чтобы хранить информацию об
   * идентификаторах location и последней в адресе geo-сущности (улица или дом).
   *
   * Кстати, город и регион имеют значение location в поле type. Типа city нет,
   * так как некоторые города (например, Москва) указываются без области (исторически сложилось).
   * Различить их можно по полю locationTypeId, где 1 — это город, 2 — регион (например, Самара).
   */
  const address = locationPathParentToChild.map(id => ({ id, type: EGeoDetailType.Location }));

  /**
   * Ищем в массиве адреса наш геообъект.
   * Если находим, выставляем ему верный тип.
   * Если не находим — добавляем его в массив адреса.
   */
  const geoIdFromAddress = address.find(({ id }) => id === geoId);

  if (geoIdFromAddress) {
    geoIdFromAddress.type = geoType as EGeoDetailType;
  } else {
    address.push({
      id: geoId,
      type: geoType as EGeoDetailType,
    });
  }

  return address;
};
